// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1519":"3b17df63","1956":"cb9706ad","2480":"cb9706ad","9237":"65870245"}[chunkId] + ".chunk.css";
};